// extracted by mini-css-extract-plugin
export default {"text":"OutlineText_text__rRP44","face":"OutlineText_face__Y1hGN"};